import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  notification,
  Upload,
  Select,
} from "antd";
import {
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
  MailFilled,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import ScreenOptions from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const SupplierUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();
    setFileList([]);

    if (props.onSuccess) props.onSuccess();
  };

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    RequestHandler.put(`/Supplier`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const downloadExcelTemplate = () => {
    window.open(
      `${config.apiUrl}/Supplier/DownloadExcel?t=${RequestHandler.getToken()}`
    );
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${
        config.apiUrl
      }/Supplier/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
  };

  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/Supplier/ImportExcel`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
      ScreenOption: ScreenOptions.screen,
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response.message,
        duration: 3,
      });
      if (!response.success) {
        downloadImportResult(info.file.response.data);
      }
      onSuccess();
    },
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="TransactionProjectTypeAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label="Tedarikçi & Taşeron Adı"
            name="name"
            rules={[
              {
                required: true,
                message: "Lütfen Tedarikçi & Taşeron adını boş bırakmayın.",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Tedarikçi & Taşeron Kodu"
            name="code"
            rules={[
              {
                required: true,
                message: "Lütfen Tedarikçi & Taşeron Kodu alanını boş bırakmayın.",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Firma Tipi"
            name="supplierType"
            rules={[
              {
                required: true,
                message: "Lütfen Firma Tipi seçimi yapın.",
              },
            ]}
          >
            <Select placeholder="Firma Tipi" allowClear>
              <Select.Option value={0}>Tedarikçi</Select.Option>
              <Select.Option value={1}>Taşeron</Select.Option>
               <Select.Option value={2}>Tedarikçi-Taşeron</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Email" name="email" rules={[{ type: "email" }]}>
            <Input type={MailFilled} />
          </Form.Item>
          <Form.Item
            label="Vergi No"
            name="vkn"
            rules={[
              {
                min: 10,
                max: 10,
                message: "Vergi No 10 karakter olmalıdır.",
              },
            ]}
          >
            <Input
              type="text"
              autoComplete="off"
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              maxLength="11"
              onInput={maxLengthCheck}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>
          <Form.Item label="Vergi Dairesi" name="taxOffice">
            <Input />
          </Form.Item>
          <Form.Item
            label="T.C. Kimlik No"
            name="tcNo"
            rules={[
              {
                min: 11,
                message: "TcNo 11 karakter olmalıdır.",
              },
            ]}
          >
            <Input
              type="text"
              autoComplete="off"
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              maxLength="11"
              onInput={maxLengthCheck}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>
          <Form.Item label="Adres" name="address">
            <TextArea rows={3} />
          </Form.Item>

          <Row justify="space-between">
            <Col>
              {/* <Button
                icon={<DownloadOutlined />}
                onClick={(() => setLoading(true), downloadExcelTemplate)}
                loading={loading}
              >
                Excel Şablonu İndir
              </Button>
              <Upload {...uploadExcelProps} fileList={fileList}>
                <Button icon={<UploadOutlined />}>Excel ile Ekle</Button>
              </Upload> */}
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default SupplierUpdateForm;
